import {Button, Card, Row} from "react-bootstrap";
import HttpRequest from "../../../Common/Http/HttpRequest";
import Notify from "../../../Common/Notify/Notify";
import {useState} from "react";


export const ComeceATrabalhar = ({row, onEventUpdated}) => {


    const [showEndDescription, setShowEndDescription] = useState(false);
    const [descriptionEnd, setDescriptionEnd] = useState('');

    const startWork = () => {

        if (showEndDescription) {
            const data = {
                startTime: new Date(),
                descriptionStart: descriptionEnd,
                project: row
            };
            HttpRequest.post(`${process.env.REACT_APP_NODE_SERVICE}/crud/entity/cflow_work_times`, data).then(() => {
                Notify.success('Obrigado por registrar suas horas...');
                onEventUpdated && onEventUpdated();
                setDescriptionEnd('');
                setShowEndDescription(false);
            });
        } else {
            Notify.warning('Informe um detalhe do atendimento');
            setShowEndDescription(true);
        }
    }

    return <Card className="ml-3" style={{width: '18rem'}}>
        <Card.Body>
            <Card.Title>{row.name}</Card.Title>
            <Card.Text>
                {row.description}
            </Card.Text>

            <Row>
                {showEndDescription &&
                    <textarea className="mb-2" style={{width: 250, height: 150}}
                              onChange={e => setDescriptionEnd(e.target.value)}></textarea>}
            </Row>
            <Button variant="primary" title="Finalizar" onClick={() => startWork(row)}>
                {showEndDescription ? 'Preparar' : 'Iniciar!'}
            </Button>

        </Card.Body>
    </Card>

}
